import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { AccountSummaryReportComponent } from "../../admin/zero-out-accounts/account-summary-report/account-summary-report.component";
import { DistrictAdministrationService } from "../services/districtadministration.service";
import { DZAAddSchoolComponent } from "./dza-add-school/dza-add-school.component";
import { ZeroFinesMealRequestModel } from "./ZeroFinesMealRequestModel";
import { ZeroMeritsRequestModel } from "./ZeroMeritsRequestModel";
import { ZeroPBISRequestModel } from "./ZeroPBISRequestModel";
import * as moment from "moment";

@Component({
	selector: "app-district-zero-accounts",
	templateUrl: "./district-zero-accounts.component.html",
	styleUrls: ["./district-zero-accounts.component.css"],
})
export class DistrictZeroAccountsComponent implements OnInit {
	constructor(
		private userService: UserService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService,
		private districtAdminService: DistrictAdministrationService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadPermissions();
		// this.loadSchoolist();
	}

	//////////////////////////////////////
	// Data
	//////////////////////////////////////
	user: any;

	SchoolID: any;
	lstSchool: any = [];

	ZeroFines: any = false;
	ZeroMeals: any = false;
	AdjustStudent: any = false;
	AdjustSchool: any = false;
	FMStartDate: Date = new Date();
	FMEndDate: Date = new Date();

	MeritStartDate: Date = new Date();
	MeritEndDate: Date = new Date();

	PBISStartDate: Date = new Date();
	PBISEndDate: Date = new Date();

	errorMessage: any = "";

	isProcessing: any = false;

	//Table
	SelectedSchools: any = [];
	lstSchoolsToChange: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	PermissionLoading: any = true;
	MeritAllowed: boolean = false;
	PBISAllowed: boolean = false;

	FMRangeOption: any = "All"; // All | Date
	MeritRangeOption: any = "All"; // All | Date
	PBISRangeOption: any = "All"; // All | Date

	//////////////////////////////////////

	//////////////////////////////////////
	// Load Data
	//////////////////////////////////////

	loadPermissions() {
		this.PermissionLoading = true;

		var result = this.districtAdminService.ZeroPermissionSelect(this.user.userID);
		result.subscribe(
			(response) => {
				var Info: any = response;

				if (Info != undefined) {
					this.MeritAllowed = Info.MeritAllowed;
					this.PBISAllowed = Info.PBISAllowed;
				}

				this.PermissionLoading = false;
			},
			(error) => {
				this.PermissionLoading = false;
			}
		);
	}

	// loadSchoolist() {
	//   var result = this.schoolService.loadSchoolList("");
	//   result.subscribe(
	//     response => {
	//       this.lstSchool = response;
	//       this.SchoolID = this.lstSchool[0].SchoolID;
	//     },
	//     error => {
	//     }
	//   )
	// }

	//////////////////////////////////////

	//////////////////////////////////////
	// Buttons
	//////////////////////////////////////
	onProcessFinesMeals() {
		this.errorMessage = "";

		//Error handling
		if (this.ZeroFines == false && this.ZeroMeals == false) {
			this.errorMessage = "No account option selected. Please select Fines, Meals, or Both";
			return;
		} else if (this.AdjustStudent == false && this.AdjustSchool == false) {
			this.errorMessage = "No adjustment type selected. Please select adjust what the student owes, adjust what the school owes, or both.";
			return;
		} else if (this.FMStartDate == undefined) {
			this.errorMessage = "Select start date";
			return;
		} else if (this.FMEndDate == undefined) {
			this.errorMessage = "Select end date";
			return;
		} else if (this.lstSchoolsToChange.length == 0) {
			this.errorMessage = "Select at least one school to update (use the the Add School(s) button)";
			return;
		} else {
			// var WarnMsg = "Zeroing out Fines/Meals Account balances is NOT REVERSIBLE, would you like to continue for the ENTIRE DISTRICT (" + this.lstSchool.length + " SCHOOLS)?";
			var WarnMsg =
				"Zeroing out Fines/Meals Account balances is NOT REVERSIBLE, would you like to continue for the ALL THE SELECTED SCHOOLS (" +
				this.lstSchoolsToChange.length;
			if (this.lstSchoolsToChange.length > 1) {
				WarnMsg += " SCHOOLS)?";
			} else {
				WarnMsg += " SCHOOL)?";
			}

			this.confirmationService.confirm({
				key: "confirm",
				acceptLabel: "Yes",
				rejectVisible: true,
				rejectLabel: "No",
				message: WarnMsg,
				header: "District Zero Account Process - Confirmation",
				icon: "fa",
				accept: () => {
					this.FinishProcessFinesMeals();
				},
				reject: () => {
					return;
				},
			});
		}
	}

	FinishProcessFinesMeals() {
		this.isProcessing = true;

		//
		// Create the Request Model
		//

		//School List
		var SchoolIDList: number[] = [];
		for (var i = 0; i < this.lstSchoolsToChange.length; i++) {
			var next = this.lstSchoolsToChange[i];

			SchoolIDList = [...SchoolIDList, Number(next.SchoolID)];
		}

		let RequestModel: ZeroFinesMealRequestModel = {
			ApplyOnFine: this.ZeroFines == true ? 1 : 0,
			ApplyOnMeal: this.ZeroMeals == true ? 1 : 0,
			ApplyCredit: this.AdjustSchool == true ? 1 : 0, //Credit
			ApplyDebit: this.AdjustStudent == true ? 1 : 0, //Debit
			c_PersonID: this.user.personID,
			UseDateRange: this.FMRangeOption == "Date" ? 1 : 0,
			StartDate: moment(this.FMStartDate).format("MM/DD/YYYY"),
			EndDate: moment(this.FMEndDate).format("MM/DD/YYYY"),
			GradeLevelID: -1,
			SchoolIDs: SchoolIDList,
		};

		var result = this.districtAdminService.DistrictZeroOutFinesMeals(RequestModel);
		result.subscribe(
			(response) => {
				this.isProcessing = false;

				var SuccessMsg = "";
				var FailMsg = "";

				if (this.ZeroFines == true && this.ZeroMeals == true) {
					SuccessMsg = "Fines and Meal accounts were zeroed out successfully";
					FailMsg = "Could not zero out Fine and Meal accounts";
				} else if (this.ZeroFines == true && this.ZeroMeals == false) {
					SuccessMsg = "Fines were zeroed out successfully";
					FailMsg = "Could not zero out Fines";
				} else if (this.ZeroFines == false && this.ZeroMeals == true) {
					SuccessMsg = "Meal accounts were zeroed out successfully";
					FailMsg = "Could not zero out Meal Accounts";
				}

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "result",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: SuccessMsg,
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "result",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: FailMsg,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	onPrintFinesMeals() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AccountSummaryReportComponent, {
			header: "Account Summary Report",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				lstSchool: this.lstSchool,
				user: this.user,
			},
		});
		ref.onClose.subscribe((response) => {});
	}

	onProcessMeritsDemerits() {
		this.errorMessage = "";

		if (this.MeritStartDate == undefined) {
			this.errorMessage = "Select start date";
			return;
		} else if (this.MeritEndDate == undefined) {
			this.errorMessage = "Select end date";
			return;
		} else if (this.lstSchoolsToChange.length == 0) {
			this.errorMessage = "Select at least one school to update (use the the Add School(s) button)";
			return;
		} else {
			// var WarnMsg = "Zeroing out Merits/Demerits is NOT REVERSIBLE, would you like to continue for the ENTIRE DISTRICT (" + this.lstSchool.length + " SCHOOLS)?";
			var WarnMsg =
				"Zeroing out Merits/Demerits is NOT REVERSIBLE, would you like to continue for the ALL THE SELECTED SCHOOLS (" + this.lstSchoolsToChange.length;
			if (this.lstSchoolsToChange.length > 1) {
				WarnMsg += " SCHOOLS)?";
			} else {
				WarnMsg += " SCHOOL)?";
			}

			this.confirmationService.confirm({
				key: "confirm",
				acceptLabel: "Yes",
				rejectVisible: true,
				rejectLabel: "No",
				message: WarnMsg,
				header: "District Zero Merits/Demerits Process - Confirmation",
				icon: "fa",
				accept: () => {
					this.FinishZeroMerits();
				},
				reject: () => {
					return;
				},
			});
		}
	}

	FinishZeroMerits() {
		this.isProcessing = true;

		//
		// Create the Request Model
		//

		//School List
		var SchoolIDList: number[] = [];
		for (var i = 0; i < this.lstSchoolsToChange.length; i++) {
			var next = this.lstSchoolsToChange[i];

			SchoolIDList = [...SchoolIDList, Number(next.SchoolID)];
		}

		let RequestModel: ZeroMeritsRequestModel = {
			UseDateRange: this.MeritRangeOption == "Date" ? 1 : 0,
			StartDate: moment(this.MeritStartDate).format("MM/DD/YYYY"),
			EndDate: moment(this.MeritEndDate).format("MM/DD/YYYY"),
			SchoolIDs: SchoolIDList,
		};

		var result = this.districtAdminService.DistrictZeroOutMerits(RequestModel);
		result.subscribe(
			(response) => {
				this.isProcessing = false;

				var RespInfo: any = response;

				if (RespInfo.IsError == false) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "result",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Merits have been zeroed out successfully",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "result",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not zero out merits: " + RespInfo.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	onProcessPBIS() {
		this.errorMessage = "";

		if (this.PBISStartDate == undefined) {
			this.errorMessage = "Select start date";
			return;
		} else if (this.PBISEndDate == undefined) {
			this.errorMessage = "Select end date";
			return;
		} else if (this.lstSchoolsToChange.length == 0) {
			this.errorMessage = "Select at least one school to update (use the the Add School(s) button)";
			return;
		} else {
			// var WarnMsg = "Zeroing out Merits/Demerits is NOT REVERSIBLE, would you like to continue for the ENTIRE DISTRICT (" + this.lstSchool.length + " SCHOOLS)?";
			var WarnMsg = "Would you like to continue zeroing out PBIS points for the ALL THE SELECTED SCHOOLS (" + this.lstSchoolsToChange.length;
			if (this.lstSchoolsToChange.length > 1) {
				WarnMsg += " SCHOOLS)?";
			} else {
				WarnMsg += " SCHOOL)?";
			}

			this.confirmationService.confirm({
				key: "confirm",
				acceptLabel: "Yes",
				rejectVisible: true,
				rejectLabel: "No",
				message: WarnMsg,
				header: "District Zero PBIS Process - Confirmation",
				icon: "fa",
				accept: () => {
					this.FinishZeroPBIS();
				},
				reject: () => {
					return;
				},
			});
		}
	}

	FinishZeroPBIS() {
		this.isProcessing = true;

		//
		// Create the Request Model
		//

		//School List
		var SchoolIDList: number[] = [];
		for (var i = 0; i < this.lstSchoolsToChange.length; i++) {
			var next = this.lstSchoolsToChange[i];

			SchoolIDList = [...SchoolIDList, Number(next.SchoolID)];
		}

		let RequestModel: ZeroPBISRequestModel = {
			UseDateRange: this.PBISRangeOption == "Date" ? 1 : 0,
			StartDate: moment(this.MeritStartDate).format("MM/DD/YYYY"),
			EndDate: moment(this.MeritEndDate).format("MM/DD/YYYY"),
			SchoolIDs: SchoolIDList,
		};

		var result = this.districtAdminService.DistrictZeroOutPBIS(RequestModel);
		result.subscribe(
			(response) => {
				this.isProcessing = false;

				var RespInfo: any = response;

				if (RespInfo.IsError == false) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "result",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "PBIS transactions were voided successfully",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "result",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not zero out PBIS: " + RespInfo.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	onAddSchool() {
		var ref = this.dialogService.open(DZAAddSchoolComponent, {
			header: "Add Schools",
			width: "fit-content",
			data: {
				SelectedSchools: this.lstSchoolsToChange,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0) {
				this.lstSchoolsToChange = response;
				this.SelectedSchools = [];
			}
		});
	}

	onRemove() {
		this.lstSchoolsToChange = this.lstSchoolsToChange.filter((school) => this.SelectedSchools.indexOf(school) == -1);
		this.SelectedSchools = [];
	}

	//////////////////////////////////////

	//////////////////////////////////////
	// Events
	//////////////////////////////////////

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}

	//////////////////////////////////////
}
